import React from 'react';
import api from 'api';
import { AppLink } from '../../../routing/containers';
import { Tabs, Tab } from 'react-bootstrap';
import { Spinner, Modal, AlertMessage } from 'hyperdb-utils';
import {
  CustomerDetails, ReservationInfo, ReservationGuestsDetails, ReservationPricesDetails, ReservationRemarksContainer
} from '../../common';
import ItemActions from './ItemActions';
import { Calendar } from '../../availabilities/containers';
import { MessagesHistory } from '../../../email/message/containers';

class Show extends React.Component {
  constructor(props) {
    super(props);
    this.handleClickBack = this.handleClickBack.bind(this);
    this.handleCustomerUpdated = this.handleCustomerUpdated.bind(this);
    this.handleOnActionSuccessful = this.handleOnActionSuccessful.bind(this);
  }
  componentDidMount() {
    this.props.api.inquiry.getObject(this.props.params.id);
  }
  render() {
    if (!this.props.objectData) return <div className="box box-primary"><Spinner show={ true } /></div>;
    const inquiry = this.props.objectData || {};
    const customer = inquiry.customer || {};
    const messages = this.props.api.getState('message').relatedMessages || [];
    const lastReceivedMessage = messages.find(m => m.folder === 'inbox') || {};
    return (
      <div className="content-wrapper">
        <section className="content-header content-header-fixed">
          <div className="row">
            <div className="col-md-7">
              <span className="btn btn-sm btn-primary" onClick={ this.handleClickBack }>
                <i className="fas fa-chevron-left"></i> Back
              </span>
              &nbsp; <h3 className="box-title">Show inquiry</h3>
            </div>
          </div>
        </section>
        <section className="content content-fixed">
          {
            this.props.successMessage
              ? <AlertMessage
                  type="success"
                  onDismiss={ this.props.api.inquiry.dismissAlert }>
                    { this.props.successMessage }
                </AlertMessage>
              : null
          }
          <div className="box box-primary">
            <Spinner show={ this.props.loading } />
            <div className="box-body show-booking">
              <div className="row">
                <div className="col-lg-5">
                  <fieldset>
                    <legend className="box-header">
                      INQUIRY #{ inquiry.reference }&nbsp;
                      <ItemActions { ...this.props } inquiry={ inquiry } onActionSuccessful={ this.handleOnActionSuccessful } repliedMessageId={ lastReceivedMessage.id } />
                    </legend>
                    <ReservationInfo reservation={ inquiry } customer={ customer } type="inquiry" />
                    <ReservationRemarksContainer
                      { ...this.props }
                      reservation={ inquiry }
                      type="inquiry"
                      api={ this.props.api }
                    />
                  </fieldset>
                </div>
                <div className="col-lg-7">
                  <Tabs defaultActiveKey={1} id="tabs-details">
                    <Tab eventKey={1} title="Details">
                      <br/>
                      <CustomerDetails customer={ customer} onCustomerUpdated={ this.handleCustomerUpdated } />
                      <div className="row">
                        <div className="col-lg-6">
                          <ReservationGuestsDetails reservation={ inquiry } />
                        </div>
                        <div className="col-lg-6">
                          <ReservationPricesDetails reservation={ inquiry } />
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey={2} title="History">
                      <br/>
                      <MessagesHistory reference={ inquiry.reference } type="inquiry" reload={ this.props.actionSuccessful && this.props.selectedAction !== 'confirm_availability' } />
                    </Tab>
                    <Tab eventKey={3} title="Calendar">
                      <Calendar booking={ inquiry } noFilters={ true } contentOnly={ true } />
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  handleClickBack() {
    if (window.previousLocation) {
      this.props.router.push(window.previousLocation);
    } else {
      this.props.api.routing.redirect(this.props.router, '/daily-rental/inquiries');
    }
  }
  handleCustomerUpdated() {
    this.props.api.inquiry.getObject(this.props.params.id);
  }
  handleOnActionSuccessful() {
    this.props.api.inquiry.getObject(this.props.params.id)
      .then(() => {
        this.props.api.inquiry.setData({ successMessage: 'Action done' });
      });
  }
}

export default api.connect(Show, 'inquiry');



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/inquiry/containers/Show.jsx